import React, { useRef, useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import Widgets from "../../../widgets";
import strings from "../../../utils/strings";
import { useTranslation } from "react-i18next";
import { getLatestVersionDocs, getOneVersionDocx, getVersionList, publishDoc, updateTncPP } from "../../../modules/TNC/tncThunk";
import { resetLatestVersionDocx, resetPublishDoc, resetUpdateTncPP } from "../../../modules/TNC/tncSlice";
import { useDispatch, useSelector } from "react-redux";
import ToastPopup from "../../../widgets/Toast/toastPopup";
import { useLocation, useNavigate } from "react-router-dom";

const EditTermsCondition = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const nav = useNavigate();
  const breadcrumbs = ["tncPP", "updateTncPP"];
  const [isDirty, setIsDirty] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showPublishModal, setShowPublishModal] = useState(false);
  const paths = [strings.navigation.termsCondition, `${location.pathname}${location.search}`];
  const { t } = useTranslation();
  const termsEnglish = useRef(null);
  const termsVietnam = useRef(null);
  const privacyEnglish = useRef(null);
  const privacyVietnam = useRef(null);
  const [tncData, setTncData] = useState({});
  const { latestVersionErr, latestVersionSuccess, updateTncPpErr, updateTncPpSuccess, publishDocSuccess, publishDocErr, versionListSuccess, oneVersionSuccess } = useSelector((state) => state.tnc);
  const filterPublishedData = versionListSuccess?.data?.versions.filter((e) => e.status === "PUBLISHED");
  const userId = filterPublishedData?.[0]?._id;

  useEffect(() => {
    dispatch(getVersionList());
  }, []);

  useEffect(() => {
    if (filterPublishedData && userId) {
      dispatch(getOneVersionDocx({ userId }));
    }
  }, [versionListSuccess]);

  useEffect(() => {
    if (updateTncPpErr) {
      ToastPopup.error(updateTncPpErr);
    }
    if (updateTncPpSuccess && updateTncPpSuccess.status === "success") {
      ToastPopup.success(t("tncUpdated"));
      setIsDirty(false);
      // window.location.reload();
    }
    dispatch(resetUpdateTncPP());
  }, [updateTncPpErr, updateTncPpSuccess]);

  useEffect(() => {
    if (publishDocErr) {
      ToastPopup.error(publishDocErr);
    }
    if (publishDocSuccess && publishDocSuccess.status === "success") {
      nav(strings.navigation.termsCondition);
      ToastPopup.success(t("tncPublished"));
    }
    dispatch(resetPublishDoc());
  }, [publishDocSuccess, publishDocErr]);

  useEffect(() => {
    if (latestVersionErr) {
      ToastPopup.error(latestVersionErr);
    }
    if (latestVersionSuccess && latestVersionSuccess.status === "success") {
      setTncData(latestVersionSuccess.data);
    }
    dispatch(resetLatestVersionDocx());
  }, [latestVersionErr, latestVersionSuccess]);

  useEffect(() => {
    dispatch(getLatestVersionDocs());
  }, [updateTncPpSuccess]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    const handlePopState = () => {
      if (isDirty) {
        setShowWarningModal(true);
        window.history.pushState(null, "", window.location.href); // Push state to prevent back navigation
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    // Push an initial state to the history stack
    window.history.pushState(null, "", window.location.href);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isDirty, setShowWarningModal]);

  const handleSaveCheck = () => {
    if (!termsEnglish.current.getContent()) {
      ToastPopup.error(t("fillEngTnc"));
      return;
    }
    if (!termsVietnam.current.getContent()) {
      ToastPopup.error(t("fillViTnc"));
      return;
    }
    if (!privacyEnglish.current.getContent()) {
      ToastPopup.error(t("fillEngPP"));
      return;
    }
    if (!privacyVietnam.current.getContent()) {
      ToastPopup.error(t("fillViPP"));
      return;
    }
    if (
      termsEnglish.current.getContent() === tncData?.content?.en?.terms_and_conditions &&
      termsVietnam.current.getContent() === tncData?.content?.vi?.terms_and_conditions &&
      privacyEnglish.current.getContent() === tncData?.content?.en?.privacy_policy &&
      privacyVietnam.current.getContent() === tncData?.content?.vi?.privacy_policy
    ) {
      ToastPopup.error(t("noChanges"));
      return;
    }
    setShowUpdateModal(true);
  };
  const handlePublishCheck = () => {
    const data = {
      content: {
        en: {
          terms_and_conditions: termsEnglish.current.getContent(),
          privacy_policy: privacyEnglish.current.getContent(),
        },
        vi: {
          terms_and_conditions: termsVietnam.current.getContent(),
          privacy_policy: privacyVietnam.current.getContent(),
        },
      },
    };
    const matchData =
      data.content.en.terms_and_conditions === oneVersionSuccess?.data?.content.en.terms_and_conditions &&
      data.content.en.privacy_policy === oneVersionSuccess?.data?.content.en.privacy_policy &&
      data.content.vi.terms_and_conditions === oneVersionSuccess?.data?.content?.vi?.terms_and_conditions &&
      data.content.vi.privacy_policy === oneVersionSuccess?.data?.content?.vi?.privacy_policy;
    console.log(matchData);
    //   const isDataSame = data.content.en.terms_and_conditions === tncData?.content?.en?.terms_and_conditions &&
    // data.content.en.privacy_policy === tncData?.content?.en?.privacy_policy &&
    // data.content.vi.terms_and_conditions === tncData?.content?.vi?.terms_and_conditions &&
    // data.content.vi.privacy_policy === tncData?.content?.vi?.privacy_policy;
    // console.log(isDataSame)
    if (tncData === null || (tncData?.status === "SAVED" && isDirty) || isDirty) {
      ToastPopup.error(t("draftFirstMsgErr"));
      return;
    } else if (matchData) {
      ToastPopup.error(t("sameContenttnc"));
    } else {
      setShowPublishModal(true);
    }
  };

  const handleCancel = () => {
    setShowUpdateModal(false);
    setShowWarningModal(false);
    setShowPublishModal(false);
  };

  const handleEditorChange = () => {
    const hasChanged =
      termsEnglish.current?.getContent() !== tncData?.content?.en?.terms_and_conditions ||
      termsVietnam.current?.getContent() !== tncData?.content?.vi?.terms_and_conditions ||
      privacyEnglish.current?.getContent() !== tncData?.content?.en?.privacy_policy ||
      privacyVietnam.current?.getContent() !== tncData?.content?.vi?.privacy_policy;
    setIsDirty(hasChanged);
  };

  const handleSaveTnc = () => {
    const data = {
      content: {
        en: {
          terms_and_conditions: termsEnglish.current.getContent(),
          privacy_policy: privacyEnglish.current.getContent(),
        },
        vi: {
          terms_and_conditions: termsVietnam.current.getContent(),
          privacy_policy: privacyVietnam.current.getContent(),
        },
      },
    };

    setShowUpdateModal(false);
    setShowWarningModal(false);
    dispatch(updateTncPP({ data }));
  };

  const handlePublishDoc = () => {
    const id = tncData._id;
    dispatch(publishDoc({ id }));
  };

  return (
    <div className="department-box article-box">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div>
        <div className="department-heading-row">
          <div className="department-heading">{t("tncEng")}</div>
        </div>
        <Editor
          apiKey="dsdmgvqy2fdi684339dzp7bvw5k9rutt9yub0yzv3ovjnef8"
          // apiKey="bfljjbavxqpfuybvp4jrmctj824e64ldqvi5wyf1bwgn282c"
          onInit={(_evt, editor) => (termsEnglish.current = editor)}
          initialValue={tncData?.content?.en?.terms_and_conditions}
          onEditorChange={handleEditorChange}
          init={{
            height: 500,
            menubar: false,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "fullscreen",
              "insertdatetime",
              "media",
              "table",
              "code",
              "wordcount",
            ],
            toolbar: "undo redo | blocks | " + "bold italic forecolor | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help",
            content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>
      <div>
        <div className="department-heading-row">
          <div className="department-heading">{t("tncVietnam")}</div>
        </div>
        <Editor
          apiKey="dsdmgvqy2fdi684339dzp7bvw5k9rutt9yub0yzv3ovjnef8"
          // apiKey="bfljjbavxqpfuybvp4jrmctj824e64ldqvi5wyf1bwgn282c"
          onInit={(_evt, editor) => (termsVietnam.current = editor)}
          initialValue={tncData?.content?.vi?.terms_and_conditions}
          onEditorChange={handleEditorChange}
          init={{
            height: 500,
            menubar: false,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "fullscreen",
              "insertdatetime",
              "media",
              "table",
              "code",
              "wordcount",
            ],
            toolbar: "undo redo | blocks | " + "bold italic forecolor | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help",
            content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>
      <div>
        <div className="department-heading-row">
          <div className="department-heading">{t("ppEng")}</div>
        </div>
        <Editor
          apiKey="dsdmgvqy2fdi684339dzp7bvw5k9rutt9yub0yzv3ovjnef8"
          // apiKey="bfljjbavxqpfuybvp4jrmctj824e64ldqvi5wyf1bwgn282c"
          onInit={(_evt, editor) => (privacyEnglish.current = editor)}
          initialValue={tncData?.content?.en?.privacy_policy}
          onEditorChange={handleEditorChange}
          init={{
            height: 500,
            menubar: false,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "fullscreen",
              "insertdatetime",
              "media",
              "table",
              "code",
              "wordcount",
            ],
            toolbar: "undo redo | blocks | " + "bold italic forecolor | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help",
            content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>
      <div>
        <div className="department-heading-row">
          <div className="department-heading">{t("ppVietnam")}</div>
        </div>
        <Editor
          apiKey="dsdmgvqy2fdi684339dzp7bvw5k9rutt9yub0yzv3ovjnef8"
          // apiKey="bfljjbavxqpfuybvp4jrmctj824e64ldqvi5wyf1bwgn282c"
          onInit={(_evt, editor) => (privacyVietnam.current = editor)}
          initialValue={tncData?.content?.vi?.privacy_policy}
          onEditorChange={handleEditorChange}
          init={{
            height: 500,
            menubar: false,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "fullscreen",
              "insertdatetime",
              "media",
              "table",
              "code",
              "wordcount",
            ],
            toolbar: "undo redo | blocks | " + "bold italic forecolor | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help",
            content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>
      <>
        <div className="save-speciality info">
          <>
            <div
              className="speciality-cancel reject"
              onClick={() => {
                isDirty ? setShowWarningModal(true) : nav(strings.navigation.termsCondition);
              }}
            >
              {t("cancel")}
            </div>
            <div className="speciality-save publish-btn" onClick={() => handlePublishCheck()}>
              {t("publishBtn")}
            </div>
            <div className="speciality-save" onClick={() => handleSaveCheck()}>
              {t("save")}
            </div>
          </>
        </div>
      </>
      <Widgets.ConfirmModal showModal={showUpdateModal} handleCancel={handleCancel} handleConfirm={handleSaveTnc} heading="updateTncPP" description="askUpdateTncPP" postive />
      <Widgets.ConfirmModal showModal={showWarningModal} handleCancel={handleCancel} handleConfirm={handleSaveTnc} heading="tncWarningHead" description="tncWarning" postive />
      <Widgets.ConfirmModal showModal={showPublishModal} handleCancel={handleCancel} handleConfirm={() => handlePublishDoc()} heading="tncPublishHead" description="tncPublishDes" postive />
    </div>
  );
};

export default EditTermsCondition;
